import PinIcon from "../../../assets/icons/PinIcon";
import SolidSpinnerIcon from "../../../assets/icons/SolidSpinnerIcon";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../../../components/ui/dropdown-menu";
import React, { useState } from "react";
import PinDashboardItem from "./PinDashboardItem";
import {
  createDashboardAPI,
  fetchDashboardsAPI,
} from "../../../api/dashboardApi";
import PinDashboardDialog from "./PinDashboardDialog";

const PinDashboard = ({ setDashboards, msgId }) => {
  const activeBrand = localStorage.getItem("activeBrand");
  const [isDropdownLoading, setIsDropdownLoading] = useState(true);
  const [dashboardList, setDashboardList] = useState([]);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDashboardCreationLoading, setIsDashboardCreationLoading] =
    useState(false);
  const [value, setValue] = useState("");

  const handleSubmit = async () => {
    await createDashboardAPI({
      setIsLoading: setIsDashboardCreationLoading,
      activeBrand,
      label: value,
    });
    const dashboards = await fetchDashboardsAPI({
      activeBrand,
      setIsLoading: setIsDropdownLoading,
    });
    setDashboards(dashboards);
    setDashboardList(dashboards);
    setIsDialogOpen(false);
  };
  return (
    <DropdownMenu
      onOpenChange={async (isOpen) => {
        if (isOpen) {
          const dashboards = await fetchDashboardsAPI({
            activeBrand,
            setIsLoading: setIsDropdownLoading,
          });
          setDashboardList(dashboards);
          setDashboards(dashboards);
        }
      }}
    >
      <DropdownMenuTrigger asChild>
        <button className="self-start text-zinc-500 hover:bg-zinc-800 hover:text-zinc-300 p-1.5 rounded-full duration-150">
          <PinIcon className="w-4 h-4" />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="bg-zinc-900 border-zinc-800 text-zinc-100">
        <DropdownMenuGroup className="w-72">
          <DropdownMenuLabel>Add to Dashboard</DropdownMenuLabel>
          <DropdownMenuSeparator className="bg-zinc-800" />

          <DropdownMenuGroup
            className={`${
              isDropdownLoading ? "h-48" : "max-h-48"
            } overflow-auto`}
          >
            {isDropdownLoading ? (
              <div className="w-full h-full flex justify-center items-center">
                <SolidSpinnerIcon className="w-5 h-5 animate-spin" />
              </div>
            ) : dashboardList.length !== 0 ? (
              dashboardList.map((dashboard) => {
                return (
                  <PinDashboardItem
                    key={dashboard._id}
                    dashboard={dashboard}
                    msgId={msgId}
                  />
                );
              })
            ) : (
              <div className="text-zinc-300 text-center text-sm">
                No dashboards found
              </div>
            )}
          </DropdownMenuGroup>
          <DropdownMenuSeparator className="bg-zinc-800" />
        </DropdownMenuGroup>

        <PinDashboardDialog
          isDialogOpen={isDialogOpen}
          setIsDialogOpen={setIsDialogOpen}
          isLoading={isDashboardCreationLoading}
          onChange={(e) => setValue(e.target.value)}
          value={value}
          title="Create Dashboard"
          handleSubmit={handleSubmit}
          description="Enter a unique name for your new dashboard"
        >
          <DropdownMenuItem
            onSelect={(event) => {
              event.preventDefault();
            }}
            className="justify-center rounded-md bg-indigo-500 text-white hover:bg-indigo-400 focus:text-white focus:bg-indigo-400"
          >
            New dashboard
          </DropdownMenuItem>
        </PinDashboardDialog>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default PinDashboard;
